import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { IOrderProductModifierOption } from 'src/types/orders';
import { getTranslate } from 'src/utils/helpers';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

interface IProps {
  option: IOrderProductModifierOption;
  productQuantity: number;
}

export const OrderProductModifierOption: FC<IProps> = memo(
  observer(({ option, productQuantity }: IProps): ReactElement => {
    const { store: orderStore } = useOrderStoreContext();

    const optionPrice: string = orderStore.formatPrice(option.price * option.quantity * productQuantity);

    return (
      <li className="order-product-modifier-option">
        <p className="order-product-modifier-option__name-wrapper">
          <span className="order-product-modifier-option__name">{getTranslate(option.name)}</span>
          <span className="order-product-modifier-option__name order-product-modifier-option__name-quantity">&nbsp;x</span>
          <span className="order-product-modifier-option__name order-product-modifier-option__name-quantity">{option.quantity}</span>
        </p>

        <p className="order-product-modifier-option__price text-nowrap">{optionPrice}</p>
      </li>
    );
  })
);
